export default {
  // Tooltip 內容
  aiModel: "AI模型",
  dataUpdate: "數據更新",
  canvasFilter: "畫布篩選",
  historyRecord: "歷史記錄",
  investigation: "調證",
  sameIpTime: "同時段同IP",

  // 數據更新面板
  dataUpdateTitle: "數據更新",
  updateInstruction: "點擊右邊更新按鈕可更新",
  investigationData: "調證數據",
  labelRemarks: "標籤備註",
  addressBalance: "地址餘額",
  lastUpdate: "上次更新：{time}",

  // 餘額更新對話框
  balanceDialogTitle: "提示",
  balanceDialogContent:
    "當前畫布地址共{count}個，更新餘額需要較長的時間，請耐心等待！",
  cancel: "取 消",
  confirm: "確 定",

  // 消息提示
  queryingBalance: "正在查詢餘額中請稍後",
  queryingData: "正在查詢數據中請稍後",
  queryingLabels: "正在查詢標籤中請稍後",
  updateSuccess: "更新成功",

  // 配置確認對話框
  configConfirmTitle: "提示",
  configConfirmMessage: "是否修改當前配置?",
  confirmButton: "確定",
  cancelButton: "取消",
  configUpdateSuccess: "修改配置成功",
  configUpdateCanceled: "已取消修改",

  // 其他
  investigationDetails: "調證詳情",
};
